<template>
    <section>
        <div class="modal fade" :id="id" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" v-if="survey.length">
                    <div class="modal-header">
                        <h5 class="modal-title">{{survey[0].question_text}}</h5>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-danger2" v-if="error">
                            <button type="button" class="close" aria-hidden="true" @click="error=0">×</button>
                            <div class="alert-body">
                                <p v-if="error_message && errors.length == 0" class="mb-0">
                                    {{ error_message }}
                                </p>
                                <div v-for="(v, k) in errors" :key="k">
                                    <p class="mb-0" v-for="item in v" :key="item">{{ item }}</p>
                                </div>
                            </div>
                        </div>
                        <div v-for="(v, i) in survey[0].options" :key="i">
                            <div class="form-check my-1">
                                <div class="icheck-primary d-inline">
                                    <input type="checkbox" :id="'c'+i" :value="v.id" v-model="options" @change="selected(v.id)">
                                    <label :for="'c'+i"> {{v.options_desc}}</label>
                                    <input type="text" class="form-control form-control-sm ml-2 input-other" v-model="other" v-if="v.id==14 && options.includes(14)">
                                </div>
                            </div>
                            <div v-if="v.sub_options.length > 0 && options.includes(v.id)" class="ml-4 form-check my-1">
                                <div v-for="(v2, i2) in v.sub_options" :key="i2">
                                    <div class="icheck-primary d-inline">
                                        <input type="checkbox" :id="'d'+i2" :value="v2.id" v-model="sub_options">
                                        <label :for="'d'+i2"> {{v2.sub_option_desc}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="btnSubmit">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import {
        required,
        requiredIf,
        minLength
    } from "vuelidate/lib/validators";

    export default {
        props: {
            id: {
                type: String,
                default: 'survey-modal',
            },
            borrower_id: {
                type: String,
                default: null,
            },
            application_id: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                errors: [],
                error: 0,
                error_message: '',
                options: [],
                sub_options: [],
                other: null,
                survey: [],
                api: {
                    ref: 0,
                    post: 0
                }
            };
        },
        validations: {
            options: {
                required,
                minLength: minLength(1),
            },
        },

        created() {},
        methods: {
            btnSubmit() {
                this.$v.options.$touch();
                if (this.$v.options.$invalid) {
                    this.error = 1;
                    this.errors = {
                        invalid: ["Please select at least 1 option in the survey"],
                    };
                } else {
                    this.apiSubmit();
                }
            },
            apiSubmit() {
                this.api.post = 1;
                const form = {
                    application_id: this.application_id,
                    borrower_id: this.borrower_id,
                    question_id: this.survey[0].id,
                    survey_id: this.survey[0].survey_id,
                    options: this.options,
                    sub_options: this.sub_options,
                    other: this.other
                };

                axios
                    .post("/api/post-survey", form)
                    .then((response) => {
                        this.api.post = 0;
                        $('#' + this.id).modal('hide');
                        this.$emit('hide');
                    })
                    .catch((error) => {
                        this.api.post = 0;
                        this.error = 1;
                        if (error.response.data) {
                            this.errors = error.response.data.errors || [];
                            this.error_message = error.response.data.message;
                        }
                    });
            },

            selected(v) {
                if (v == 8) {
                    if (!this.options.includes(v)) {
                        this.sub_options = [];
                    }
                }
                if (v == 14) {
                    if (!this.options.includes(v)) {
                        this.other = null;
                    }
                }
            },

            getSurvey() {
                this.api.ref = 1;
                axios.get('/api/get-survey', {
                        params: {
                            id: 1
                        }
                    })
                    .then(response => {
                        this.api.ref = 0;
                        this.survey = response.data.survey;
                    })
                    .catch((error) => {
                        this.api.ref = 0;
                    })
            },
        },
        computed: {
            processingAPI() {
                return Object.values(this.api).includes(1);
            },
        },
        mounted() {
            $('#' + this.id).on("show.bs.modal", () => {
                this.getSurvey();
                this.options = [];
                this.sub_options = [];
                this.other = null;
            });
        },
    };
</script>



<style scoped>
    .input-other {
        display: inline-block;
        width: 250px;
        /* border-top: 0;
        border-left: 0;
        border-right: 0;
        border-radius: 0; */
    }

    @media (max-width: 767px) {
        .input-other {
            display: inline-block;
            width: 210px;
        }
    }
</style>